module.exports = __webpack_public_path__ + "media/packs/static/fonts/circular-std/bold-4bae1919c290b401036664748d04e1d9.woff";